<template>
  <v-card>
    <div class="d-flex align-center pl-2 pr-5 pt-2">
      <div
        class="caption font-weight-bold flex-grow-0 mx-2 grey--text text--darken-1"
      >
        Medium Contact Labels
      </div>
      <v-spacer />
      <v-btn @click="showLabelForm = true" color="primary" text rounded icon>
        <v-icon v-text="$getIcon('mdiPlus')"></v-icon>
      </v-btn>
    </div>
    <v-card-text>
      <div
        v-for="(label, index) in this.labels"
        :key="`label-${index}`"
        class="d-flex align-center px-2"
        :class="{ 'grey lighten-4': index % 2 === 0 }"
      >
        <div class="d-flex align-center flex-grow-1 py-2">
          <div style="flex-basis: 10rem">{{ label.label }}</div>
          <div style="flex-grow: 1">{{ label.validating_regex || "N/A" }}</div>
          <div style="flex-basis: 3.99909rem">
            <v-btn
              icon
              small
              text
              @click="
                () => {
                  formValues = label;
                  showLabelForm = true;
                }
              "
              color="primary"
            >
              <v-icon v-text="$getIcon('mdiPencil')"></v-icon>
            </v-btn>
            <v-btn icon small text @click="delItem(label.id)" color="error">
              <v-icon v-text="$getIcon('mdiDelete')"></v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-dialog v-model="showLabelForm" max-width="400">
      <div class="red--text white">
        {{ formValidator.getError("non_field_errors") }}
      </div>
      <form class="d-flex align-center pa-2 white" @submit.prevent="submit">
        <div style="flex-basis: 10rem">
          <v-text-field
            label="Name *"
            placeholder="Add new label"
            v-model="formValues.label"
            :error-messages="formValidator.getError('label')"
            required
            class="mr-2"
          >
          </v-text-field>
        </div>
        <div style="flex-grow: 1;">
          <v-text-field
            label="Validation Regex"
            placeholder="Validation Regex"
            v-model="formValues.validating_regex"
            :error-messages="formValidator.getError('validating_regex')"
          >
          </v-text-field>
        </div>

        <div style="flex-basis: 5rem">
          <v-btn icon small text type="submit" color="primary">
            <v-icon v-text="$getIcon('mdiContentSave')"></v-icon>
          </v-btn>
          <v-btn
            icon
            small
            text
            @click="
              () => {
                showLabelForm = false;
              }
            "
            color="error"
          >
            <v-icon v-text="$getIcon('mdiCancel')"></v-icon>
          </v-btn>
        </div>
      </form>
    </v-dialog>
  </v-card>
</template>

<script>
import { FormValidator } from "rhr-core-shell";

export default {
  props: ["communication_medium"],
  resourceUrl: "/api/v1/crm/communication-mediums-labels/",
  data() {
    return {
      labels: [],
      showLabelForm: false,
      formValues: {
        communication_medium: this.communication_medium
      },
      formValidator: new FormValidator()
    };
  },
  mounted() {
    this.fetchLabels();
  },
  watch: {
    showLabelForm(newVal) {
      if (!newVal) {
        this.formValues = {};
      }
    }
  },
  methods: {
    async fetchLabels() {
      const params = {
        communication_medium_id: this.communication_medium
      };
      const { data } = await this.$axios.get(
        `${this.$options.resourceUrl}choices/`,
        {
          params
        }
      );
      this.labels = data;
    },
    async submit() {
      let method = "post";
      let url = this.$options.resourceUrl;
      if (this.formValues.id) {
        method = "patch";
        url = `${url}${this.formValues.id}/`;
      }

      try {
        const { data } = await this.$axios[method](url, {
          ...this.formValues,
          communication_medium: this.communication_medium
        });

        if (method === "post") {
          this.labels.splice(0, 0, data);
        } else {
          let editedObj = this.labels.find(
            obj => obj.id === this.formValues.id
          );
          this.labels.splice(this.labels.indexOf(editedObj), 1, data);
        }
        this.showLabelForm = false;
      } catch (error) {
        this.formValidator.setError(error.response.data);
      }
    },
    async delItem(id) {
      let res = await this.$confirm("Do you really want to delete?", {
        title: "Warning"
      });
      if (res) {
        try {
          await this.$axios.delete(`${this.$options.resourceUrl}${id}/`);
          let editedObj = this.labels.find(obj => obj.id === id);
          this.labels.splice(this.labels.indexOf(editedObj), 1);
        } catch (error) {
          this.$store.dispatch("shell/showSnackbar", {
            text: "Error deleting this resouece",
            color: "error"
          });
        }
      }
    }
  }
};
</script>
